module.exports = __webpack_public_path__ + "img/entwined@2x.1902863.jpg";